export default __webpack_public_path__ + "static/media/zczj.06e04425.jpg";